export class ChargingZoneUpdate {
    name: string;
    status: number;
    locationId: number;
    title: string;
    description: string;
}